import { createContext } from 'react';

export const DialogConfigContext = createContext(null);
